import requests, { Response, SOURCE } from '@/helpers/requests'
import techTaskModule from './modules/tech-task'
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)


interface AuthStoreState {
    authKey: string|null;
    authErrorMessage: string|null;
    authUsername: string|null;
}


interface AuthorizeMeResponse extends Response {
    access_token: string|null;
    message: string;
}


interface FetchUsernameResponse extends Response {
    data: {
        username: string;
    };
}


const store = new Vuex.Store({
    modules: {
        techTask: techTaskModule
    },
    state: {
        authKey: null,
        authErrorMessage: null,
        authUsername: null
    } as AuthStoreState,
    actions: {
        async login(context, payload): Promise<void> {
            const response = await requests.rawPost('/authorize-me', {
                source: SOURCE,
                ...payload
            }) as AuthorizeMeResponse
            if (response.access_token) {
                context.commit('updateAuthToken', {
                    authKey: response.access_token,
                    authErrorMessage: null
                })
                await context.dispatch('fetchUsername')
            }
        },
        async validateAuth(context) {
            if (context.state.authKey) {
                const response = await requests.rawPost('/validate-auth', {
                    source: SOURCE
                }, true) as AuthorizeMeResponse
                if (response.access_token) {
                    context.commit('updateAuthToken', {
                        authKey: response.access_token,
                        authErrorMessage: null
                    })
                    await context.dispatch('fetchUsername')
                } else {
                    await context.dispatch('clearAuthToken', response.message)
                }
            } else {
                await context.dispatch('clearAuthToken', 'Please log in with your CSM username to use internal tools.')
            }
        },
        async fetchUsername(context) {
            try {
                const response = await requests.post('/support/internal/username/fetch') as FetchUsernameResponse
                context.commit('updateUsername', response.data.username)
            } catch(e) {
                // Since we don't have a nice way to do this in the backend,
                // this is our hack for logging out with a nice message when
                // someone without a whitelisted username logs in.
                await context.dispatch('clearAuthToken', e.message)
            }
        },
        clearAuthToken(context, authErrorMessage: string|null) {
            context.commit('updateAuthToken', {
                authKey: null,
                authErrorMessage: authErrorMessage
            })
        }
    },
    mutations: {
        initializeStore(state) {
            // Check the state exists in localStorage.
            const storedStore = localStorage.getItem('store')
            if (typeof storedStore === 'string') {
                // Replace the state object with the stored item
                this.replaceState(
                    Object.assign(state, JSON.parse(storedStore))
                )
            }
        },
        updateAuthToken(state: AuthStoreState, newState: AuthStoreState) {
            state.authKey = newState.authKey
            state.authErrorMessage = newState.authErrorMessage
        },
        updateUsername(state: AuthStoreState, authUsername: string) {
            state.authUsername = authUsername
        }
    }
})

store.subscribe((mutation, state) => {
    // Store the state object as a JSON string
    localStorage.setItem('store', JSON.stringify(state))
})

export default store
